import { type UpdateResolver } from "@urql/exchange-graphcache";
import { gql } from "urql";

import { type DenyMembershipRequestPayload, type Maybe } from "@/gql/graphql";

type Result = Maybe<{
  denyMembershipRequest: Maybe<DenyMembershipRequestPayload>;
}>;

const updater: UpdateResolver<Result, null> = (result, _args, cache) => {
  if (result?.denyMembershipRequest?.membershipRequest) {
    cache.updateQuery(
      {
        query: gql`
          query DENY_MEMERSHIP_REQUEST_UPDATER($organizationId: String!) {
            organization(id: $organizationId) {
              id
              membershipRequests {
                nodes {
                  id
                }
              }
            }
          }
        `,
        variables: {
          organizationId:
            result.denyMembershipRequest.membershipRequest.organizationId,
        },
      },
      (data) => {
        data.organization.membershipRequests.nodes =
          data.organization.membershipRequests.nodes.filter(
            (x: { id: string }) =>
              x.id !== result.denyMembershipRequest?.membershipRequest?.id,
          );
        return data;
      },
    );
  }
};

export const denyMembershipRequest = updater as unknown as UpdateResolver;
